<template>
  <div>
    <v-container fluid>
      <SlaTimeout />
      <v-divider class="my-4" />
      <CloseByBot />
      <v-divider class="my-4" />
      <TicketAssignment />
      <v-divider class="my-4" />
      <TicketType />
      <template v-if="isCustomerSupportService && selectedBot.unlock_survey">
        <v-divider class="my-4" />
        <SurveySetting />
      </template>
    </v-container>
  </div>
</template>

<script>
import SlaTimeout from './SlaTimeout.vue'
import CloseByBot from './CloseByBot.vue'
import TicketAssignment from './TicketAssignment.vue'
import TicketType from './TicketType.vue'
import SurveySetting from './CustomerSupportService/SurveySetting.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'SettingView',
  components: {
    SlaTimeout,
    CloseByBot,
    TicketAssignment,
    TicketType,
    SurveySetting
  },
  computed: {
    ...mapGetters(['selectedBot', 'isCustomerSupportService'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/index.vue